import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 64 64",
  style: {"background-color":"#ffffff00"},
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6 32C6 17.64 17.674 6 32.076 6c14.4 0 26.076 11.64 26.076 26S46.477 58 32.076 58C17.674 58 6 46.36 6 32z",
      fill: "#86bc4d"
    }, null, -1),
    _createElementVNode("path", {
      d: "M18 22h28v20H18V22z",
      fill: "#55acba"
    }, null, -1),
    _createElementVNode("path", {
      d: "M37 30v3h2v-3h-2zm-6 0v3h2v-3h-2zm-6 0v3h2v-3h-2z",
      stroke: "#fff",
      fill: "#fff"
    }, null, -1)
  ])))
}
export default { render: render }